import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  enterpriseTagsKey,
  updateEnterpriseTagsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { tagsListKey } from '@features/enterprise/constants';

type useUpdatetagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdatetags = ({
  setErrorText = () => {},
}: useUpdatetagsProps) => {
  const client = useQueryClient();

  const { mutate: updatetags, isLoading: isupdatetagsLoading } = useMutation({
    mutationFn: (variables: {
      tag: string;
      tag_id: number;
      company_id?: number | string;
      template_id?: number;
    }) =>
      axiosInstance
        .post(updateEnterpriseTagsRoute, variables, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([enterpriseTagsKey]);
        client.invalidateQueries([tagsListKey]);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    updatetags,
    isupdatetagsLoading,
  };
};
